import { defaultPm2PrintChunkClassName } from '@provider/print';
import { generateJsxKey } from '@utils/ast';
import { PrintImage } from './image.print.js';
import { printEmptyImageComponent } from './printer.to-jsx.js';
import { jsx } from 'react/jsx-runtime';

const printImageComponentPaper = (node, context) => {
  return [{
    containerClassName: defaultPm2PrintChunkClassName,
    content: /*#__PURE__*/jsx(PrintImage, {
      caption: node.meta.caption,
      displayCaption: node.options.displayCaption,
      enableScaling: node.options.enableScaling,
      imageSrc: node.imageSrc,
      imageWidth: node.meta.imageWidth
    }, generateJsxKey(context))
  }];
};
const printEmptyImageComponentPaper = (node, context) => {
  return [{
    containerClassName: defaultPm2PrintChunkClassName,
    content: printEmptyImageComponent(node, context)
  }];
};
const imageComponentPaperPrinters = {
  "image-component": printImageComponentPaper,
  "empty-image-component": printEmptyImageComponentPaper
};

export { imageComponentPaperPrinters, printImageComponentPaper };
//# sourceMappingURL=printer.to-paper.js.map
